import { ICON_SHARE_FACEBOOK } from '../../../modules/svg/svg'

interface FaceBookShareButtonType {
  linkUrl: any
  imgSrc?: any
  onClickHandler?: () => void
}
const FaceBookShareButton = ({ linkUrl, imgSrc, onClickHandler = null }: FaceBookShareButtonType) => {
  const handleClick = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=ringleplus.com/${linkUrl}`)
    if (onClickHandler) {
      onClickHandler()
    }
  }

  return (
    <button onClick={handleClick}>
      <img src={imgSrc ? imgSrc : ICON_SHARE_FACEBOOK} className="w-[47px]" />
    </button>
  )
}

export default FaceBookShareButton
